import React from 'react';

export type UseTimeoutToggle = (timeout: number) => [boolean, F0, F0];

export const useTimeoutToggle: UseTimeoutToggle = (timeout) => {
  const [toggle, setToggle] = React.useState(false);

  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(
    () => () => clearTimeout(timeoutRef.current as NodeJS.Timeout),
    [timeout],
  );

  const handleToggle = React.useCallback(() => {
    setToggle(true);
    timeoutRef.current = setTimeout(() => {
      setToggle(false);
    }, timeout);
  }, [timeout]);

  const handleClose = React.useCallback(() => {
    clearTimeout(timeoutRef.current as NodeJS.Timeout);
    setToggle(false);
  }, []);

  return [toggle, handleToggle, handleClose];
};
